import React from 'react'

import { Trans } from 'react-i18next'
import { ShareButton } from '../Share/ShareButton'
import './ResultPageHeader.scss'

export const ResultPageHeader = () => {
  return (
    <div className="ResultPageHeader">
      <div className="ResultPageHeader-Title">
        <Trans i18nKey={'Result:shareWith'} components={{ em: <em /> }} />

        <ShareButton />
      </div>
    </div>
  )
}
